import { render, staticRenderFns } from "./DadosCadastraisForm.vue?vue&type=template&id=44418506&"
import script from "./DadosCadastraisForm.vue?vue&type=script&lang=js&"
export * from "./DadosCadastraisForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports